<template>
<div>
<div class="text-center mt-4"><img src="/images/supalytic-icon.svg" width="50"></div>
<div class="homepage_heading mt-2 mb-4 py-4 px-3">How it works</div>

<div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>
<div v-else-if="items.length == 0" class="text-center py-2">No data</div>

<div v-else>
<div v-for="(item, index) in items" :key="index.id" class="row mt-2">
  <div class="col-md-6 pb-4 mx-auto">
    <div class="card h-100 home">
      <div class="card-body d-flex flex-column justify-content-center align-items-center">
        <div class="step_number">{{ item.id }}</div>
        <div class="step_title mt-3">{{ item.name }}</div>
        <div class="step_description" v-html="item.description"></div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</template>

<script>
export default {

  data() {
    return {
      loading: true,
      items: [],
    };
  },

  created() {
    this.getData();
  },

  methods: {

    getData() {

      axios.get('/get/steps').
      then((response) => {
        this.items = response.data;
        this.loading = false;
      });

    },
  },
};
</script>